import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import { Page } from 'Components/wordpress/page/Page';

import { WordpressData } from '../../@types/Wordpress';

import styles from '../../WordpressPages.scss';

export type PageContentProps = {
  data: WordpressData | null;
};

export const PageContent: React.FC<PageContentProps> = ({ data }) => {
  const match = useRouteMatch();

  if (!data?.content) {
    return null;
  }

  let path = match.path?.substring(1);
  if (path === 'guides/:subdir?') {
    const [first] = path.split('/');
    path = first;
  }

  const { content, title } = data;

  return (
    <Page
      content={content || ''}
      title={title ?? ''}
      wordpressContent={{
        className: `${styles.wordpressContent} ${styles.wordpressContent}_content_${path}`,
      }}
    />
  );
};
